import React from 'react';

import { SEO } from 'main/components';
import {
  Hero,
  RacePerformance,
  AdvancedTimingDetection,
  Specifications,
  NoTranspodersNeeded,
  About,
  CTA,
} from 'modules/lapRf';

export const LapRf = () => {
  return (
    <>
      <SEO seoTitle="ImmersionRC LapRF 8 - RF Detection for Drone Detector - Orqa" />
      <section className="laprf-section">
        <Hero />
        <RacePerformance />
        <AdvancedTimingDetection />
        <Specifications />
        <NoTranspodersNeeded />
        <About />
        <CTA />
      </section>
    </>
  );
};
